import type { FC } from "react";
import { Col, Row } from "react-bootstrap";
import { useAppSelector } from "../../../redux/hooks";
import { APP_LINKS } from "../../../modules/merchandising/constants";
import { ADVERTISING, CONTENT, DEALS, DYNAMIC_PRICING, NEW_PRODUCT_LAUNCH } from "./constants";
import checkApplication from "../../../utils/checkApplication";
import PlacementCard from "./cards/PlacementCard";
import PromotionsCard from "./cards/PromotionsCard";
import PricingCard from "./cards/PricingCard";
import ContentCard from "./cards/ContentCard";
import NPICard from "./cards/NPICard";
import Card from "../../core/basic/Card";
import { css } from "../../../../styled-system/css";

interface AppStatsCardProps {
  category?: string | null;
}

const AppStatsCard: FC<AppStatsCardProps> = ({ category = null }) => {
  const user = useAppSelector((state) => state.user);
  const channel = useAppSelector((state) => state.channel.currentChannel);

  const cards = APP_LINKS.filter((c) => checkApplication(user, c.app));

  return (
    <Card className={css({ padding: "medium" })}>
      <Row>
        {cards.find((c) => c.app === ADVERTISING) && <PlacementCard category={category} />}
        {cards.find((c) => c.app === DEALS) && (
          <>
            <Col className="border-top" xs={12}></Col>
            <PromotionsCard category={category} />
          </>
        )}
        {cards.find((c) => c.app === DYNAMIC_PRICING) && (
          <>
            <Col className="border-top" xs={12}></Col>
            <PricingCard category={category} />
          </>
        )}
        {cards.find((c) => c.app === CONTENT) && (
          <>
            <Col className="border-top" xs={12}></Col>
            <ContentCard category={category} />
          </>
        )}
        {cards.find((c) => c.app === NEW_PRODUCT_LAUNCH && channel === "amazon") && (
          <>
            <Col className="border-top" xs={12}></Col>
            <NPICard category={category} />
          </>
        )}
      </Row>
    </Card>
  );
};

export default AppStatsCard;
